import React from 'react';
import { useTranslation } from 'react-i18next';
import { Banner } from '@unmind/design-system';
import { hasCompletedIndexRecently } from '../utils/timeBetweenIndex';
import RoutePath from '../../../App/RoutePath';
import withIndexRetakeFrequency, {
  MINIMUM_DAYS_BETWEEN_INDEXES,
  WithIndexRetakeFrequencyProps,
} from '../Questionnaire/withIndexRetakeFrequency';

interface ScoreChartEmptyStateProps extends WithIndexRetakeFrequencyProps {
  latestScoreDate: Date;
  category: string;
}

const ScoreChartEmptyState = ({
  latestScoreDate,
  indexFrequency = MINIMUM_DAYS_BETWEEN_INDEXES,
  category,
}: ScoreChartEmptyStateProps) => {
  const { t: translate } = useTranslation('track');

  const showWellbeingTrackerCTA = !hasCompletedIndexRecently(
    indexFrequency,
    latestScoreDate.toString(),
  );

  return (
    <Banner
      title={translate('wellbeing.scores.chart_empty_state.title')}
      description={translate('wellbeing.scores.chart_empty_state.description', {
        category: category.toLowerCase(),
      })}
      iconName="feedback"
      button={
        showWellbeingTrackerCTA
          ? {
              label: translate(
                'wellbeing.scores.chart_empty_state.cta_button.text',
              ),
              variant: 'primary',
              to: RoutePath.UnmindIndex,
              size: 'medium',
            }
          : undefined
      }
    />
  );
};

export default withIndexRetakeFrequency(ScoreChartEmptyState);
